
export const getAdminConfig = (t) => {
    return [
        {
            title: t("SidebarConfig.adminConfig.admin.title"),
            path: "/admin/panel",
            icon: "account_circle",
            tooltip:
                t("SidebarConfig.adminConfig.admin.tooltip"),
        },
    ];
}

export const getSidebarConfig = (t, regionConfig = {}) => {
    // regionConfig.staticPages can be either:
    // - an object with keys for pages (truthy to enable), e.g.
    //   { contact: true, licenseGenerator: true }
    // - or an object with per-page overrides, e.g.
    //   { contact: { path: "/dashboard/contact", icon: "contact_mail", tooltip: "..." }, ... }
    const staticPages = regionConfig.staticPages || {};

    const availablePagesMap = {
        contact: {
            translationBase: "SidebarConfig.sidebar.contact",
            defaultPath: "/dashboard/contact",
            defaultIcon: "contact_mail",
        },
        licenseGenerator: {
            translationBase: "SidebarConfig.sidebar.licenseGenerator",
            defaultPath: "/dashboard/license",
            defaultIcon: "card_membership",
        },
    };

    const items = [];

    Object.entries(availablePagesMap).forEach(([key, meta]) => {
        const cfg = staticPages[key];

        // include page only if cfg is truthy (boolean true) or an object (overrides)
        if (cfg) {
            const item = {
                title: t(`${meta.translationBase}.title`),
                path: typeof cfg === "object" && cfg.path ? cfg.path : meta.defaultPath,
                icon: typeof cfg === "object" && cfg.icon ? cfg.icon : meta.defaultIcon,
            };

            // tooltip optional:
            // - if cfg.tooltip === false -> omit tooltip entirely
            // - if cfg.tooltip is a string starting with "SidebarConfig." -> translate it
            // - if cfg.tooltip is a string (literal) -> use it
            // - otherwise fall back to default translation
            if (typeof cfg === "object" && "tooltip" in cfg) {
                if (cfg.tooltip === false) {
                    // omit
                } else if (typeof cfg.tooltip === "string" && cfg.tooltip.startsWith("SidebarConfig.")) {
                    item.tooltip = t(cfg.tooltip);
                } else {
                    item.tooltip = cfg.tooltip;
                }
            } else {
                const defaultTooltipKey = `${meta.translationBase}.tooltip`;
                const defaultTooltipTranslated = t(defaultTooltipKey);
                // add default tooltip only if translation exists (t returned something different than key)
                if (defaultTooltipTranslated && defaultTooltipTranslated !== defaultTooltipKey) {
                    item.tooltip = defaultTooltipTranslated;
                }
            }

            items.push(item);
        }
    });

    return items;
};


